import HarvestTemplateDatalist from "components/entities/templates/agriculture/work/HarvestTemplateDatalist";
import { AppRoutes } from "config/router";

const WorkNewItemModel = () => {
    return (
        <HarvestTemplateDatalist
            newUrl={AppRoutes.AGRICULTURE_WORK_HARVEST_FORM}
            onClickUrl={i => `${AppRoutes.AGRICULTURE_WORK_HARVEST_FORM}?template=${i?.id}`}
        />
    );
};

export default WorkNewItemModel;
